var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"title":_vm.$t('hunt.confirmLeaveTitle'),"close-enabled":!_vm.leavingHunt,"buttons":_vm.buttons},on:{"close":_vm.close}},[_vm._v(" "+_vm._s(_vm.$t('hunt.confirmLeaveMessage'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }